// extracted by mini-css-extract-plugin
export default {"searchResults":"ClientsPage_searchResults__Ygtom","mappedResults":"ClientsPage_mappedResults__Kzco1","noSearchResults":"ClientsPage_noSearchResults__hM9WT"};